import React, { createContext, useContext } from 'react';
import { DndProvider } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/esm/HTML5toTouch';
import useAnnotationReducer from 'reducers/annotationReducer';
import useBooksReducer from 'reducers/booksReducer';
import useCanvasReducer from 'reducers/canvasReducer';
import useDBReducer from 'reducers/dbReducer';
import useExtendedContentReducer from 'reducers/extendedContentReducer';
import useGlobalReducer from 'reducers/globalReducer';
import useLoginReducer from 'reducers/loginReducer';
import useReaderReducer from 'reducers/readerReducer';
import useSideToolReducer from 'reducers/sideToolReducer';
import useUserReducer from 'reducers/userReducer';
import useUserSettingsReducer from 'reducers/userSettingsReducer';
import useCourseReducer from 'reducers/courseReducer';
import useWordGridReducer from 'reducers/wordGridReducer';
const Context = createContext();

export const StoreTypes = {
  global: 'global',
  books: 'books',
  canvas: 'canvas',
  toolbar: 'toolbar',
  reader: 'reader',
  user: 'user',
  db: 'db',
  sideTool: 'sideTool',
  router: 'router',
  annotation: 'annotation',
  extendedContent: 'extendedContent',
  login: 'login',
  settings: 'settings',
  course: 'course',
  wordGrid: 'wordGrid'
};

export const useStore = store => {
  const reducers = useContext(Context);
  if (!store) return reducers;
  if (!Object.keys(StoreTypes).includes(store)) {
    throw new Error(`Store doesn't contain ${store}`);
  }
  return reducers[store];
};

const Provider = ({ children, router }) => {
  const reducers = {
    [StoreTypes.global]: useGlobalReducer(),
    [StoreTypes.books]: useBooksReducer(),
    [StoreTypes.canvas]: useCanvasReducer(),
    [StoreTypes.reader]: useReaderReducer(),
    [StoreTypes.user]: useUserReducer(),
    [StoreTypes.db]: useDBReducer(),
    [StoreTypes.sideTool]: useSideToolReducer(),
    [StoreTypes.annotation]: useAnnotationReducer(),
    [StoreTypes.extendedContent]: useExtendedContentReducer(),
    [StoreTypes.router]: router,
    [StoreTypes.login]: useLoginReducer(),
    [StoreTypes.settings]: useUserSettingsReducer(),
    [StoreTypes.course]: useCourseReducer(),
    [StoreTypes.wordGrid]: useWordGridReducer()
  };

  return (
    <DndProvider options={HTML5toTouch}>
      <Context.Provider value={{ ...reducers }}>{children}</Context.Provider>
    </DndProvider>
  );
};

export default Provider;
